import type {ITimeoutService} from 'angular';
import HistoricalPlacesMap from './historical-places-map';
import type HistoricalPlacesDataService from './historical-places.data-service';
import type {
    HistoricalPlace,
    HistoricalPlacesRequest
} from './historical-places.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import KpUniversalForm from '../../commons/value-editors/kp-universal-form/KpUniversalForm.svelte';
import type {KpUniversalFormSettings} from '../../commons/value-editors/kp-universal-form/types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const historicalPlacesWindowTemplateUrl = require('./historical-places-window.tpl.pug');

const provenienceTypeToStringMap = {
    'db34514b-998c-4dab-9787-b585fb55ac4e': 'marker_knihovna_jina',
    'b40a36a3-d2f1-4e6d-9872-4d8b586c22d1': 'marker_knihovna_slechticka',
    '90a16232-0c84-4a5f-ac82-d45300c20be5': 'marker_knihovna_mestanska',
    'a6b88df3-eaad-40ff-8e96-0619d3f92fe9': 'marker_knihovna_cirkevni'
};

export default class HistoricalPlacesController {

    public static getFormSettings(historicalPlacesDataService: HistoricalPlacesDataService): Promise<any> {
        return historicalPlacesDataService.getFormSettings();
    }

    public query: HistoricalPlacesRequest = {};
    public map: HistoricalPlacesMap;
    public historicalPlacesWindowTemplateUrl = historicalPlacesWindowTemplateUrl;
    public places: HistoricalPlace[] | 'error';
    public kpUniversalFormComponent = KpUniversalForm;

    /*@ngInject*/
    constructor(private uiGmapIsReady, $timeout: ITimeoutService, private CONTEXT_PATH: string, private historicalPlacesDataService: HistoricalPlacesDataService, public formSettings: KpUniversalFormSettings<Record<string, any>>) {
        this.map = new HistoricalPlacesMap($timeout);

        uiGmapIsReady.promise(1).then(() => this.find());
    }

    @ngAsync()
    public async find(query?: HistoricalPlacesRequest) {
        this.map.hideWindow();

        try {
            this.places = await this.historicalPlacesDataService.query(query);
            this.map.markers = this.places.map((place) => this.mapPlaceToMarker(place))
        } catch (e) {
            this.places = 'error';
        }
    }

    private mapPlaceToMarker(place) {
        return {
            id: place.id,
            coordinates: {
                latitude: place.coordinates.lat,
                longitude: place.coordinates.lng
            },
            name: place.name,
            period: {
                from: place.fromYear,
                to: place.toYear
            },
            authorityUrl: `${this.CONTEXT_PATH}/records/${place.recordId}`,
            label: `<a href="${this.CONTEXT_PATH}/records/${place.recordId}">${place.name}</a>`,
            icon: {
                url: `${this.CONTEXT_PATH}/resources/ext/proveniences-map/${provenienceTypeToStringMap[place.type.id]}.png`,

                // @ts-ignore probably global namespace ?
                scaledSize: new google.maps.Size(48, 48)
            }
        };
    }
}